import useMenu from "../../../logic/Menu";
import Style from "./Menu.module.scss";

const Menu = () => {
  const { header, style } = useMenu();

  return (
    <div className={Style.site_header}>
      {header && style && <div dangerouslySetInnerHTML={{ __html: style }} />}
      {header && <div dangerouslySetInnerHTML={{ __html: header }} />}
    </div>
  );
};

export default Menu;
